<template>
  <va-create-layout>
    <doctors-form :title="title" :item="item"></doctors-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
